/**
 * 判断字符串是否为图片URL地址
 * @param url 需要判断的URL字符串
 * @returns boolean 是否为图片URL
 */
export const isImageUrl = (url: string): boolean => {
    if (!url) return false;

    // 检测 data URL 类型的图片（如 base64 编码图片）
    if (/^data:image\/([a-zA-Z]*);base64,/.test(url)) {
      return true;
    }

    // 检查是否为有效的URL格式
    try {
        new URL(url);
    } catch {
        return false;
    }

    // 常见的图片文件扩展名
    const imageExtensions = [
        '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg', '.ico',
        '.JPG', '.JPEG', '.PNG', '.GIF', '.BMP', '.WEBP', '.SVG', '.ICO'
    ];

    // 检查URL是否以图片扩展名结尾
    return imageExtensions.some(ext => url.toLowerCase().endsWith(ext));
};